module.exports = __webpack_public_path__ + "img/iostore.a3aa76dc.png";